var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.totalUnreadMessageCount)?_c('span',{staticClass:"badge badge-danger",staticStyle:{"font-size":"x-small"}},[_vm._v(_vm._s(_vm.totalUnreadMessageCount))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }